/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `modelchecker` - modelchecker
 * @export
 */
export const RevisionTaskNameEnum = {
  MODELCHECKER: "modelchecker",
} as const;
export type RevisionTaskNameEnum = (typeof RevisionTaskNameEnum)[keyof typeof RevisionTaskNameEnum];

export function instanceOfRevisionTaskNameEnum(value: any): boolean {
  for (const key in RevisionTaskNameEnum) {
    if (Object.prototype.hasOwnProperty.call(RevisionTaskNameEnum, key)) {
      if (RevisionTaskNameEnum[key as keyof typeof RevisionTaskNameEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RevisionTaskNameEnumFromJSON(json: any): RevisionTaskNameEnum {
  return RevisionTaskNameEnumFromJSONTyped(json, false);
}

export function RevisionTaskNameEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RevisionTaskNameEnum {
  return json as RevisionTaskNameEnum;
}

export function RevisionTaskNameEnumToJSON(value?: RevisionTaskNameEnum | null): any {
  return value as any;
}

export function RevisionTaskNameEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): RevisionTaskNameEnum {
  return value as RevisionTaskNameEnum;
}
